// for selector
export const Selector = {
    statusOptions: [
        { id: 1, name: "ปกติ" },
        { id: 2, name: "บาดเจ็บ" },
        { id: 3, name: "เสียชีวิต" },
        { id: 4, name: "เปราะบาง" },
    ],
    genderOptions: [
        { id: 1, name: "ชาย" },
        { id: 2, name: "หญิง" },
    ],
    officerTypeOption: [
        { id: 1, name: "ในพื้นที่", },
        { id: 2, name: "นอกพื้นที่", },
    ],
    formatOptions: [
        { id: 1, name: "รูปแบบปฎิทิน", },
        { id: 2, name: "รูปแบบรายการ", },
    ],
    sortOption: [
        { id: 1, name: "แสดงอัปเดตล่าสุด", action: "desc" },
        { id: 2, name: "แสดงข้อมูลเก่าสุด", action: "asc" },
    ],
    sortOption1: [
        { id: 1, name: "แสดงรายการล่าสุด", action: "desc" },
        { id: 2, name: "แสดงรายการเก่าสุด", action: "asc" },
    ],
    deathCauseOption: [
        { id: 0, name: "เกี่ยวกับภัยพิบัติ", },
        { id: 1, name: "ไม่เกี่ยวกับภัยพิบัติ", },
    ],
    downloadReportOption: [
        { id: 1, name: "1 วัน" },
        { id: 2, name: "1 เดือน" },
        { id: 3, name: "หลายเดือนต่อเนื่องกัน" },
        { id: 4, name: "1 ปี" },
    ],
    monthOption: [
        { id: 1, name: "มกราคม" },
        { id: 2, name: "กุมภาพันธ์" },
        { id: 3, name: "มีนาคม" },
        { id: 4, name: "เมษายน" },
        { id: 5, name: "พฤษภาคม" },
        { id: 6, name: "มิถุนายน" },
        { id: 7, name: "กรกฎาคม" },
        { id: 8, name: "สิงหาคม" },
        { id: 9, name: "กันยายน" },
        { id: 10, name: "ตุลาคม" },
        { id: 11, name: "พฤศจิกายน" },
        { id: 12, name: "ธันวาคม" },
    ],
    dateOption: [
        { id: 1, name: "1" },
        { id: 2, name: "2" },
        { id: 3, name: "3" },
        { id: 4, name: "4" },
        { id: 5, name: "5" },
        { id: 6, name: "6" },
        { id: 7, name: "7" },
        { id: 8, name: "8" },
        { id: 9, name: "9" },
        { id: 10, name: "10" },
        { id: 11, name: "11" },
        { id: 12, name: "12" },
        { id: 13, name: "13" },
        { id: 14, name: "14" },
        { id: 15, name: "15" },
        { id: 16, name: "16" },
        { id: 17, name: "17" },
        { id: 18, name: "18" },
        { id: 19, name: "19" },
        { id: 20, name: "20" },
        { id: 21, name: "21" },
        { id: 22, name: "22" },
        { id: 23, name: "23" },
        { id: 24, name: "24" },
        { id: 25, name: "25" },
        { id: 26, name: "26" },
        { id: 27, name: "27" },
        { id: 28, name: "28" },
        { id: 29, name: "29" },
        { id: 30, name: "30" },
        { id: 31, name: "31" },
    ],
};
// for filter
export const Filter = {
    victimStatusOptions: [
        { id: "", name: "แสดงทุกสถานะผู้ประสบภัย" },
        { id: 1, name: "ปกติ" },
        { id: 2, name: "บาดเจ็บ" },
        { id: 3, name: "เสียชีวิต" },
        { id: 4, name: "เปราะบาง" },
    ],
    populationStatusOptions: [
        { id: "", name: "แสดงทุกสถานะ" },
        { id: 1, name: "ปกติ" },
        { id: 2, name: "บาดเจ็บ" },
        { id: 3, name: "เสียชีวิต" },
        { id: 4, name: "เปราะบาง" },
    ],
    genderOptions: [
        { id: "", name: "แสดงทุกเพศ" },
        { id: 1, name: "ชาย" },
        { id: 2, name: "หญิง" },
    ],
    officerTypeOption: [
        { id: "", name: "แสดงทุกประเภทเจ้าหน้าที่" },
        { id: 1, name: "ในพื้นที่", },
        { id: 2, name: "นอกพื้นที่", },
    ],
    typeOption: [
        { id: "", name: "แสดงทุกสถานะการใช้งาน" },
        { id: 1, name: "กำลังใช้งาน" },
        { id: 2, name: "ปิดการใช้งาน" },
    ],
};

// แปลง ค.ศ. -> พ.ศ.
const toBE = (ce) => ce + 543;

// selector: ไม่มี "แสดงทุกปี"
export const makeYearOptions = () => {
    const current = new Date().getFullYear(); // ปีปัจจุบัน
    const items = [];
    for (let y = current; y >= current; y--) {  // จะได้แค่ปีปัจจุบัน
        items.push({
            id: y,
            name: String(toBE(y)), // พ.ศ.
            action: String(y),     // ค.ศ.
        });
    }
    return items;
};

// filter: มี "แสดงทุกปี" นำหน้า
export const makeYearFilterOptions = () => ([
    { id: '', name: 'แสดงทุกปี', action: '' },
    ...makeYearOptions(),
]);

